import { useMutation, useQuery } from "@tanstack/react-query";
import * as FeedbackApi from "../api/feedback";
import { FeedbackSubmission, VerbatimFeedback } from "../components/cards/VerbatimsCard/FeedbackState";
import useUserContext from "../components/Authorization/useUserContext";

export default function useUserFeedback() {
  const user = useUserContext();

  const getUserFeedbackByIds = (documentIds: string[]) => {
    return useQuery<VerbatimFeedback[]>({
      queryKey: ["userFeedback", documentIds],
      queryFn: () => FeedbackApi.getUserFeedback(documentIds, user),
    });
  };

  const getAllUserFeedback = () => {
    return useQuery<VerbatimFeedback[]>({
      queryKey: ["userFeedbackAll", user.selectedRoles],
      queryFn: () => FeedbackApi.getAllUserFeedback(user),
    });
  };

  const { mutateAsync: saveUserFeedback } = useMutation({
    mutationFn: ({ payload }: { payload: FeedbackSubmission<unknown> }): Promise<VerbatimFeedback> => {
      return FeedbackApi.addUserFeedback(payload, user);
    },
  });

  return {
    getUserFeedbackByIds,
    getAllUserFeedback,
    saveUserFeedback,
  };
}
